import { Edition } from "@carnegie-learning/cure-types";
import { FeathersServicePagination } from "@carnegie-learning/data-access-core";
import { createAction, props } from "@ngrx/store";

export const LOAD_ACTIVEEDITIONS = "[Courses] Load Active Editions";
export const LOAD_ACTIVEEDITIONS_FAIL = "[Courses] Load Active Editions Fail";
export const LOAD_ACTIVEEDITIONS_SUCCESS =
    "[Courses] Load Active Editions Success";

export const LoadActiveEditions = createAction(
    LOAD_ACTIVEEDITIONS,
    props<{
        payload: string; // TODO: CURE: use schoolID
    }>()
);

export const LoadActiveEditionsFail = createAction(
    LOAD_ACTIVEEDITIONS_FAIL,
    props<{
        payload: any;
    }>()
);

export const LoadActiveEditionsSuccess = createAction(
    LOAD_ACTIVEEDITIONS_SUCCESS,
    props<{
        payload: FeathersServicePagination<Edition>;
    }>()
);
